// admin/src/lib/types.ts
//
// Row shapes for the tables this admin site reads/writes
// (supabase/migrations/0025_media_library.sql, plus the exercises columns
// from 0004/0013). snake_case throughout, matching the DB columns 1:1 --
// this package has no sync queue or camelCase boundary to keep in sync
// with, unlike the app's src/features/builder/schema.ts.

import type { EquipmentCategory, EquipmentClass, ExerciseKind, LoadMode, MediaKind, Sport } from './vocab';

export type AdminRow = {
  user_id: string;
  email: string;
  created_at: string;
  created_by: string | null;
};

export type EquipmentRow = {
  id: string;
  name_en: string;
  name_he: string;
  category: EquipmentCategory;
  class: EquipmentClass;
  photo_path: string | null;
  sort: number;
  archived_at: string | null;
  created_at: string;
  updated_at: string;
};

export type ExerciseRow = {
  id: string;
  owner_id: string | null;
  name_en: string;
  name_he: string;
  muscle_group: string;
  equipment: EquipmentClass;
  kind: ExerciseKind;
  increment_kg: number;
  sport: Sport;
  load_mode: LoadMode;
  track_reps: boolean;
  track_weight: boolean;
  track_time: boolean;
  track_distance: boolean;
  track_rir: boolean;
  description: string | null;
  description_en: string | null;
  description_he: string | null;
  /** Wave 16d how-to (migration 0045) -- fetched by the list page for the "How-to" filter, not just the edit page. */
  description_steps_en?: string[] | null;
  description_steps_he?: string[] | null;
  image_path: string | null;
  muscles: string[];
  archived_at: string | null;
  created_at: string;
  updated_at: string;
};

export const EXERCISE_SELECT_COLUMNS =
  'id, owner_id, name_en, name_he, muscle_group, equipment, kind, increment_kg, sport, load_mode, ' +
  'track_reps, track_weight, track_time, track_distance, track_rir, description, description_en, description_he, ' +
  'description_steps_en, description_steps_he, ' +
  'image_path, muscles, archived_at, created_at, updated_at';

export type ExerciseEquipmentRow = {
  exercise_id: string;
  equipment_id: string;
  sort: number;
};

export type ExerciseMediaRow = {
  id: string;
  exercise_id: string;
  kind: MediaKind | 'equipment' | 'demo_video';
  rendition: string;
  path: string;
  sort: number;
  title_en: string | null;
  title_he: string | null;
  poster_path: string | null;
  created_at: string;
  updated_at: string;
};

export type MediaSlotRow = {
  slot: string;
  label: string;
  path: string | null;
  focal_x: number;
  focal_y: number;
  updated_at: string;
};
